<template>
    <div class="downloader-item">
        <div
            class="
                d-flex
                align-items-center
                justify-content-between
                text-sm
                mb-2s
            "
        >
            <div class="d-flex align-items-center flex-grow-1">
                <i class="fas fa-arrow-down mr-2s"></i>
                <div
                    :title="item.name"
                    class="d-inline-block text-truncate max-w-140-px"
                >
                    {{ item.name }}
                </div>
            </div>
            <div class="position-relative text-right w-90-px flex-shrink-0">
                <span class="text-nowrap">
                    {{ speed }}
                </span>
                <div
                    class="
                        downloader-item__buttons
                        position-absolute
                        top-0
                        bottom-0
                        right-0
                        left-0
                        bg-white
                        z-index-9
                    "
                >
                    <b-button
                        variant="transparent"
                        class="bg-hover-white-smoke-5 w-20-px h-20-px p-0"
                        @click="cancel"
                    >
                        <i class="far fa-times"></i>
                    </b-button>
                </div>
            </div>
        </div>
        <b-progress :value="item.processPercent" height="5px"></b-progress>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    name: 'DownloaderItem',
    props: {
        item: {
            type: Object,
            required: true,
            default() {
                return {};
            },
        },
    },
    data() {
        return {
            speed: '0 B/s',
            intervalFunc: null,
        };
    },
    created() {
        this.displaySpeed();
    },
    beforeDestroy() {
        clearInterval(this.intervalFunc);
        this.intervalFunc = null;
    },
    methods: {
        ...mapActions('downloader', ['cancelDownload']),
        cancel() {
            this.cancelDownload(this.item);
        },
        displaySpeed() {
            this.intervalFunc = setInterval(() => {
                this.speed = this.item.speed;
            }, 1000);
        },
    },
};
</script>

<style lang="scss" scoped>
@import 'DownloaderItem';
</style>
